import { useState } from "react";
import Overview from "./Overview";

export default function HomePage() {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <div>
      {/* Page Title */}
      <h2 className="fw-semibold mb-4">Home</h2>

      {/* Sub-navigation (Overview tab) */}
      <div className="border-bottom mb-4">
        <button
          className={`btn btn-link text-decoration-none px-0 me-4 ${
            activeTab === "overview" ? "text-primary fw-semibold" : "text-dark"
          }`}
          onClick={() => setActiveTab("overview")}
        >
          Overview
        </button>
      </div>

      {/* Content */}
      {activeTab === "overview" && <Overview />}
    </div>
  );
}
